import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface ITerminateOrchestrationPayload {
    instanceId: string;
    reason?: string;
}

async function terminateOrchestration(
    payload: ITerminateOrchestrationPayload,
): Promise<void> {
    await apiClient.post(
        `/FunctionAppsStarter/TerminateOrchestration/${payload.instanceId}`,
        { reason: payload.reason },
    );
}

export function useTerminateOrchestration() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: terminateOrchestration,
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({
                queryKey: ["orchestration-detail", variables.instanceId],
            });
            queryClient.invalidateQueries({
                queryKey: ["orchestration-instances"],
            });
        },
    });
}
